export default __webpack_public_path__ + "static/media/ponentes__Eduardo_Piquero.144a5361.jpg";